__turbopack_context__.v({
  "wide": "chartWideAt2xl-module__hbw91q__wide",
});
